export default __webpack_public_path__ + "c7a5b377e553d2d2e55a169a239380df.png";